import React, { useEffect } from 'react';
import { node } from 'prop-types';
import { useHelmet, TitleTag, MetaTag } from '@thd-nucleus/thd-helmet';

const metadataHandler = ({ props }) => {
  const tags = [];
  if (props.title) {
    tags.push(new TitleTag(props.title));
  }
  if (props.description) {
    tags.push(new MetaTag({ name: 'description', content: props.description, id: 'description' }));
  }
  return tags;
};

const Metadata = (props) => {
  const { children } = props;

  useHelmet('rootMetadataHanlder', { props }, metadataHandler, [props.title, props.description]);
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('metadata.ready'); }, []);

  return (
    children
  );
};

Metadata.propTypes = {
  children: node,
};

Metadata.defaultProps = {
  children: null,
};

export { Metadata };
